import React from 'react';
import '../styles/ProjectInfo.scss';

const Snippet = ({ name, content }) => {
  content = (typeof content === 'string') ? [content] : content;
  content = content.map((str, i) => {
    let markup = str;
    if (str.substr(0, 2) === '::') {
      markup = <span>{str.substr(2)}</span>;
    }
    return <p key={i}>{markup}</p>;
  });
  return (
    <div className="snippet">
      <h3>{name}</h3>
      {content}
    </div>
  );
};

Snippet.propTypes = {
  name: React.PropTypes.string.isRequired,
  content: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.array
  ])
};

const Buttons = ({ buttons }) => {
  if (!buttons.length) return null;
  const markup = buttons.map((button, i) => (
    <a key={i} href={button.url} target="_blank">{button.text}</a>
  ));
  return <div className="buttons">{markup}</div>;
};

Buttons.propTypes = {
  buttons: React.PropTypes.array.isRequired
};

const ProjectInfo = ({ project }) => (
  <div className="ProjectInfo">
    <Snippet name="Client" content={project.info.client} />
    <Snippet name="Timeline" content={project.info.timeline} />
    <Snippet name="Description" content={project.info.description} />
    <Snippet name="Tools" content={project.info.tools} />
    <Buttons buttons={project.info.buttons} />
  </div>
);

ProjectInfo.propTypes = {
  project: React.PropTypes.object.isRequired
};

export default ProjectInfo;



// WEBPACK FOOTER //
// ./src/components/ProjectInfo.js